var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalSettingsColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21513_1336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 8.00065C14.6673 4.31875 11.6825 1.33398 8.00065 1.33398C4.31875 1.33398 1.33398 4.31875 1.33398 8.00065C1.33398 11.6825 4.31875 14.6673 8.00065 14.6673C8.56178 14.6673 9.33398 14.7449 9.33398 14.0007C9.33398 13.5947 9.12278 13.2815 8.91305 12.9703C8.60612 12.515 8.30218 12.0642 8.66732 11.334C9.11178 10.4451 9.85252 10.4451 10.9883 10.4451C11.5563 10.4451 12.2229 10.4451 13.0007 10.334C14.4013 10.1339 14.6673 9.27292 14.6673 8.00065Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 8.00065C14.6673 4.31875 11.6825 1.33398 8.00065 1.33398C4.31875 1.33398 1.33398 4.31875 1.33398 8.00065C1.33398 11.6825 4.31875 14.6673 8.00065 14.6673C8.56178 14.6673 9.33398 14.7449 9.33398 14.0007C9.33398 13.5947 9.12278 13.2815 8.91305 12.9703C8.60612 12.515 8.30218 12.0642 8.66732 11.334C9.11178 10.4451 9.85252 10.4451 10.9883 10.4451C11.5563 10.4451 12.2229 10.4451 13.0007 10.334C14.4013 10.1339 14.6673 9.27292 14.6673 8.00065Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 10.0016L4.6718 10",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 10.0016L4.6718 10",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 5.66602C7.88627 5.66602 8.33398 5.2183 8.33398 4.66602C8.33398 4.11373 7.88627 3.66602 7.33398 3.66602C6.7817 3.66602 6.33398 4.11373 6.33398 4.66602C6.33398 5.2183 6.7817 5.66602 7.33398 5.66602Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 5.66602C7.88627 5.66602 8.33398 5.2183 8.33398 4.66602C8.33398 4.11373 7.88627 3.66602 7.33398 3.66602C6.7817 3.66602 6.33398 4.11373 6.33398 4.66602C6.33398 5.2183 6.7817 5.66602 7.33398 5.66602Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.5C5.05228 8.5 5.5 8.05228 5.5 7.5C5.5 6.94772 5.05228 6.5 4.5 6.5C3.94772 6.5 3.5 6.94772 3.5 7.5C3.5 8.05228 3.94772 8.5 4.5 8.5Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.5C5.05228 8.5 5.5 8.05228 5.5 7.5C5.5 6.94772 5.05228 6.5 4.5 6.5C3.94772 6.5 3.5 6.94772 3.5 7.5C3.5 8.05228 3.94772 8.5 4.5 8.5Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7.33398C11.5523 7.33398 12 6.88627 12 6.33398C12 5.7817 11.5523 5.33398 11 5.33398C10.4477 5.33398 10 5.7817 10 6.33398C10 6.88627 10.4477 7.33398 11 7.33398Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7.33398C11.5523 7.33398 12 6.88627 12 6.33398C12 5.7817 11.5523 5.33398 11 5.33398C10.4477 5.33398 10 5.7817 10 6.33398C10 6.88627 10.4477 7.33398 11 7.33398Z",
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21513_1336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalSettingsColor);
export default __webpack_public_path__ + "static/media/personal_settings_color.d7ff21e35369e42852f32b32e905260a.svg";
export { ForwardRef as ReactComponent };